import React from "react";

const PasswordsMismatch = ({ setArePasswordsSame }) => {
  return (
    <>
      <div className="signinup-error-message-modal">
        <div className="signinup-error-message-container">
          <div>
            <span className="font-dark-blue1">
              Les mots de passe ne correspondent pas.
            </span>
          </div>

          <div
            className="signinup-error-message-close-button-container"
            onClick={() => setArePasswordsSame(true)}
          >
            <button>Fermer</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordsMismatch;
